import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-answer-sheet',
  templateUrl: './answer-sheet.component.html',
  styleUrls: ['./answer-sheet.component.scss']
})
export class AnswerSheetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
